import { filter, prop, sortBy } from "ramda";

function initSorter() {
    for (const element of document.querySelectorAll('[data-do="sort"]')) {
        element.addEventListener("click", (_event) => {
            const currentUrl = new URL(window.location.href);
            const currentSort = JSON.parse(
                currentUrl.searchParams.get("sort") ?? "[]",
            );

            const result = [
                ...filter(
                    (sortItem) =>
                        sortItem.property !== element.dataset.property,
                    currentSort,
                )
            ];

            //Add sorting for currently set sort only if its value is not NONE
            element.dataset.direction !== 'NONE' && result.push({
													property: element.dataset.property,
													priority: element.dataset.priority,
													direction: element.dataset.direction,
												})

            currentUrl.searchParams.set(
                "sort",
                JSON.stringify(sortBy(prop('priority'), result)).toString(),
            );
            location.href = currentUrl.toString();
        });
    }
}

export { initSorter };
